import React from 'react';
import { PermissionsContextValues, PermissionsProvider } from './context';
import RolesList from './roles/List';
import PermissionsMain from './permissions/Main';

interface Props extends PermissionsContextValues {
	type: 'roles' | 'permissions';
}

function Permissions(props: Props) {
	const { type, ...rest } = props;

	return (
		<PermissionsProvider value={{ ...rest }}>
			{type === 'roles' && <RolesList />}
			{type !== 'roles' && <PermissionsMain />}
		</PermissionsProvider>
	);
}

export default Permissions;
